import React, { Suspense, useEffect, useMemo, useState } from "react";
import * as S from "./Topology.styles";
import useMedia from "react-use/lib/useMedia";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { IConfig } from "./Topology.types";
import { InView } from "react-intersection-observer";

const RiveComponent = React.lazy(() =>
  import("./RiveComponent").then(({ RiveComponent }) => ({
    default: RiveComponent,
  })),
);

export const Topology = ({
  config,
  mobileConfig,
}: Readonly<{ config: IConfig; mobileConfig: IConfig }>) => {
  const [isMounted, setIsMounted] = useState(false);
  const isSmallScreen = useMedia(BREAKPOINTS.MOBILE_AND_DOWN, false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const url = useMemo(() => {
    return isSmallScreen ? mobileConfig.src : config.src;
  }, [isSmallScreen, config.src, mobileConfig.src]);

  if (!isMounted) {
    return <S.TopologyContainer>{null}</S.TopologyContainer>;
  }

  return (
    <S.TopologyContainer
      $overrideAspectRatio={config?.aspectRatio}
      $overrideMobileAspectRatio={mobileConfig?.aspectRatio}
      className="in-view-monitor"
    >
      <InView as="div" threshold={0.3} trackVisibility delay={100}>
        {({ inView, ref }) => (
          <S.TopologyInViewContainer ref={ref}>
            <Suspense fallback={null}>
              <RiveComponent url={url} isInView={inView} />
            </Suspense>
          </S.TopologyInViewContainer>
        )}
      </InView>
    </S.TopologyContainer>
  );
};
